import React, {Component} from 'react';
import SocialMedia from '../../../Shared/components/Contact/SocialMedia';
import {browserHistory} from 'react-router';

import ShareButtonsBox from '../../../Shared/components/SocialMediaButtons/ShareButtonsBox'
import {
    PATH_ADOPTAR,
    PATH_BUSCADOR_ANIMALES_ADMIN,
    PATH_BUSCADOR_ANIMALES_ADMIN_ANIMAL_NUEVO,
    PATH_PROTECTORA_ID
} from "../../../../App/RouterAdopta";
import TeamingButton from "../../../Shared/components/Contact/TeamingButton";
import Descripcion from "../../../Shared/components/components/Descripcion/Descripcion";
import CardCarrousellImages from "../../../Shared/components/Cards/CardCarrousellImages";
import NewV2ContactComponent from "../../../Shared/components/Contact/NewV2ContactComponent";
import {LazyLoadImage} from "react-lazy-load-image-component";
import {ELEMENTS, TIPOS_EVENTOS} from "../../../../analytics/config/analyticsParamsFrontEnd";
import ContactEntityComponent from "../../../Shared/components/Contact/ContactEntityComponent";
import {sendEvent} from "../../../../analytics/analitycs"
import {ADS_TYPES, AdsManagerContainer} from "../../../Ads/components/AdsManagerContainer";


class NewProtectoraDetail extends Component {
    
    constructor(props) {
        super(props);
        
        this.state = {
            modeEmail_2: false,
            showModalContactByEmail: false
        }
        this.configEstadoContacto = {
            id: "",
            collSize: "divSelectContactoProtectora",
            seleccionado: "",
            placeHolder: "Estados",
            data: ["¿Alguna pregunta?"],
            messageWhatsapp: "Hola%20Quiero%20m%C3%A1s%20informaci%C3%B3n%20sobre%20vosotros%20",
            idSelect: "contactoProtectora",
            divSelect: '.divSelectContactoProtectora',
            tipo: 'protectora'
        };
        
        //Config información
        this.configInformation = {
            titleHead: "Redes Sociales",
            socials: [
                {
                    url: this.props.infoProtectoraDetail.facebook && this.props.infoProtectoraDetail.facebook.url ? this.props.infoProtectoraDetail.facebook.url : '',
                    socialIcon: "lab la-facebook-f"
                },
                {
                    url: this.props.infoProtectoraDetail.twitter && this.props.infoProtectoraDetail.twitter.url ? this.props.infoProtectoraDetail.twitter.url : '',
                    socialIcon: "lab la-twitter"
                },
                {
                    url: this.props.infoProtectoraDetail.instagram && this.props.infoProtectoraDetail.instagram.url ? this.props.infoProtectoraDetail.instagram.url : '',
                    socialIcon: "lab la-instagram"
                }
            ]
        };
        
        this.showImagenVideo = this.showImagenVideo.bind(this);
        this.hideDetail = this.hideDetail.bind(this);
        this.changeModeEmail = this.changeModeEmail.bind(this);
        this.hideEmailContact = this.hideEmailContact.bind(this);
        this.backSearch = this.backSearch.bind(this);
        this.backToHall = this.backToHall.bind(this);
        this.insertAnimal = this.insertAnimal.bind(this);
        this.clickLinkDescripcion = this.clickLinkDescripcion.bind(this);
        this.clickLinkTeamingDescripcion = this.clickLinkTeamingDescripcion.bind(this);
        this.clickEmailDescripcion = this.clickEmailDescripcion.bind(this);
        this.onShowButtonTeaming = this.onShowButtonTeaming.bind(this);
        this.onClickButtonTeaming = this.onClickButtonTeaming.bind(this);
        this.onClickSendEmail = this.onClickSendEmail.bind(this);
        this.onCloseModalContact = this.onCloseModalContact.bind(this);
    }
    
    showImagenVideo() {
        if (this.props.showProtectora) {
            $('#showImagesVideoProtectora').text("Ver fotos");
        } else {
            $('#showImagesVideoProtectora').text("Ocultar fotos");
        }
        this.props.showImagenVideoProtectora();
    }
    
    hideDetail() {
    }
    
    
    hideEmailContact() {
        this.changeModeEmail(false);
    }
    
    
    
    changeModeEmail(mode) {
        //console.log("EntityProtectoraDetail::changeModeEmail()");
        
        this.setState({modeEmail_2: mode})
        
    }
    
    backSearch() {
        browserHistory.push(PATH_ADOPTAR);
    }
    
    backToHall() {
        browserHistory.push(PATH_BUSCADOR_ANIMALES_ADMIN);
    }
    
    onShowButtonTeaming() {
        //console.log("NewProtectoraDetail::onShowButtonTeaming()");
        if (this.props.infoProtectoraDetail?._id) sendEvent(TIPOS_EVENTOS.IMPRESION, ELEMENTS.PROTECTORA.TEAMING_BUTTON, {id_protectora: this.props.infoProtectoraDetail._id});
        
    }
    
    onClickButtonTeaming() {
        //console.log("NewProtectoraDetail::onClickButtonTeaming()");
        if (this.props.infoProtectoraDetail?._id) sendEvent(TIPOS_EVENTOS.CLIC, ELEMENTS.PROTECTORA.TEAMING_BUTTON, {id_protectora: this.props.infoProtectoraDetail._id});
    }
    
    insertAnimal() {
        // var animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
        
        // $('#animals-list-container').removeClass("fadeIn").addClass('fadeOut');
        // $('.card-detail-protectora').removeClass("fadeIn").addClass('fadeOut');
        // $('.protectora-detail__heading').removeClass("fadeIn").addClass('animated-400ms fadeOut');
        
        // var width = window.innerWidth;
        
        this.props.resetInfoAnimalDetail("animalsProtectora");
        
        // if (width < 992) {
        //     $('.icon-wrapper').removeClass('animated-500ms fadeInLeft').addClass('animated-500ms fadeOutLeft').one(animationEnd, function () {
        //         browserHistory.push('/buscador/admin/animal/nuevo');
        //     });
        // } else {
        //     $('#animals-filter').removeClass('fadeInLeft').addClass('fadeOutLeft').one(animationEnd, function () {
        browserHistory.push(PATH_BUSCADOR_ANIMALES_ADMIN_ANIMAL_NUEVO);
        // });
        // }
    }
    
    
    clickLinkDescripcion() {
        //console.log("CardInfoDetailProtectora::clickLinkDescripcion()");
        sendEvent(TIPOS_EVENTOS.CLIC, ELEMENTS.PROTECTORA.LINK_DESCRIPCION, {id_protectora: this.props.infoProtectoraDetail._id});
    }
    
    clickLinkTeamingDescripcion() {
        //console.log("CardInfoDetailProtectora::clickLinkTeamingDescripcion()");
        sendEvent(TIPOS_EVENTOS.CLIC, ELEMENTS.PROTECTORA.TEAMING_BUTTON, {id_protectora: this.props.infoProtectoraDetail._id});
    }
    
    clickEmailDescripcion() {
        //console.log("CardInfoDetailProtectora::clickEmail()");
        // this.props.modeEmail(true, this.props.animalsControl);
        sendEvent(TIPOS_EVENTOS.CLIC, ELEMENTS.PROTECTORA.EMAIL_DESCRIPCION, {id_protectora: this.props.infoProtectoraDetail._id});
    
        // modeEmail(true, this.props.animalsControl);
        this.setState({
            showModalContactByEmail: true
        })
        
    }
    
    onCloseModalContact() {
        //console.log("EntityProtectoraDetail::onCloseModalContact()");
        this.setState({
            showModalContactByEmail: false
        })
    }
    
    onClickSendEmail() {
        // sendEvent(TIPOS_EVENTOS.CLIC, ELEMENTS.PROTECTORA.CONTACT_EMAIL, {id_protectora: this.props.infoProtectoraDetail._id})
    }
    
    render() {
        let showInfo = false;
        let eventBack;
        let textBack;
        if (this.props.access.isLogin && this.props.access.id === this.props.infoProtectoraDetail._id && this.props.adminAnimals) {
            eventBack = this.backToHall;
            textBack = "Volver al panel";
        } else {
            eventBack = this.backSearch;
            textBack = "Volver a la búsqueda";
        }
        
        let animalsControlPlus;
        let classSource = "";
        let direccion;
        let {img_principal} = this.props.infoProtectoraDetail;
        if (Object.keys(this.props.infoProtectoraDetail).length !== 0 && this.props.infoProtectoraDetail._id !== undefined && !this.props.modeEmail_2) {
            showInfo = true;
            
            const direccionObj = this.props.infoProtectoraDetail.direccion;
            animalsControlPlus = (this.props.animalsControl + "2");
            if (direccionObj && direccionObj.ocultar_direccion_exacta) {
                direccion = "Zona de " + direccionObj.municipio + ", " + direccionObj.provincia;
            } else if (direccionObj && !direccionObj.ocultar_direccion_exacta && direccionObj.calle && direccionObj.numero) {
                direccion = direccionObj.calle + ", " + direccionObj.numero + ", " + direccionObj.municipio + ", " + direccionObj.provincia
            } else {
                direccion = direccionObj.municipio + " (" + direccionObj.provincia + ")"
            }
            
            if (!img_principal || !img_principal.url) {
                img_principal = {
                    url: process.env.CDN_URL + '/images/adoptaunanimal/default/protectora2.png'
                }
            }
        }
        const teaming = this.props.infoProtectoraDetail.teaming && this.props.infoProtectoraDetail.teaming.url && this.props.infoProtectoraDetail.teaming.nick ? this.props.infoProtectoraDetail.teaming : undefined;
        let url;
        try {
            url = (this.props.infoProtectoraDetail.URL) ? this.props.infoProtectoraDetail.URL.replace("https://", "").replace("http://", "").replace("www.", "").split("/").shift() : undefined;
        } catch (e) {
            console.error(e)
            url = this.props.infoProtectoraDetail.URL
        }
        // console.log("NewProtectoraDetail::render()");
        const hasSocialMedia = ["facebook","intagram","twitter","teaming"].some(rrss=>this.props.infoProtectoraDetail[rrss]?.url != undefined)
        return (
            <div className="row">
                <div className="card-block card-detail-protectora">
                    {showInfo &&
                        <div className="cardInfoDetailShow">
                            <div className="informationDetailDescriptionUp">
                                <div className="informationDetailDescriptionUpLeft_noHidenResponsive">
                                    <LazyLoadImage threshold={150} src={img_principal.url} alt=""
                                                   className="embed-responsive"/>
                                </div>
                                <div className="informationDetailDescriptionUpRight informationDetailProtectora">
                                    <h4 className="card-title">{this.props.infoProtectoraDetail.nombre}</h4>
                                    <div className="informationDetailProtectora__row">
                                        <div>
                                            <div className="informationDetailProtectora__content_row">
                                            <div className="informationDetailProtectora__content_row">
                                            <span
                                                className="las la-map-marker-alt informationDetailProtectora__icon"></span>
                                                <span
                                                    className="direccion informationDetailProtectora__text">Dirección: </span>
                                                <span
                                                    className="direccion-data informationDetailProtectora__text">{direccion}</span>
                                            </div>
                                        </div>
                                        <div className="informationDetailProtectora__content_row">
                                            <span
                                                className="las la-shipping-fast informationDetailProtectora__icon"></span>
                                            <span className="realizaEnvios informationDetailProtectora__text"> Realiza envio: </span>
                                            <span
                                                className="realizaEnvio-data informationDetailProtectora__text">{(this.props.infoProtectoraDetail.realiza_envios ? "Si" : "No")}</span>
                                        </div>
                                        <div className="informationDetailProtectora__content_row">
                                            <span
                                                className="las la-globe-europe informationDetailProtectora__icon"></span>
                                            <span className="web informationDetailProtectora__text"> Página web: </span>
                                            {url
                                                ? <a href={url} target='_blank'
                                                     className="web-data informationDetailProtectora__text">{url}</a>
                                                :
                                                <span
                                                    className="web-data informationDetailProtectora__text">sin página web</span>
                                            }
                                        </div>
                                        {/*<div className="informationDetailProtectora__column">*/}
                                        {/*    <div className="informationDetailProtectora__content_row">*/}
                                        {/*        <span*/}
                                        {/*            className="las la-question informationDetailProtectora__icon"></span>*/}
                                        {/*        <span*/}
                                        {/*            className="estado informationDetailProtectora__text"> Estado: </span>*/}
                                        {/*        <span*/}
                                        {/*            className="estado-data informationDetailProtectora__text">{this.props.infoProtectoraDetail.estado}</span>*/}
                                        {/*    </div>*/}
                                        {/*</div>*/}
                                    </div>
                                        <AdsManagerContainer type={ADS_TYPES.ROBAPAGINAS}/>
                                    </div>

                                    <div className="informationDetailProtectora__row-100">
                                        <div className="div-rrss-contacto-protectora">
                                            {hasSocialMedia && <div className="social-media-block">
                                                <SocialMedia
                                                    configInformation={this.configInformation}
                                                    animalsControl={this.props.animalsControl}
                                                    animalsControlDetail={this.props.animalsControlDetail}
                                                />
                                            </div>}
                                            <div className="contacto-block">
                                                <NewV2ContactComponent
                                                    infoProtectoraDetail={this.props.infoProtectoraDetail}
                                                    tipoContacto={"protectora"}
                                                    urlWhastapp={process.env.HOST_ADOPTA + PATH_PROTECTORA_ID + this.props.infoProtectoraDetail._id}
                                                    configEstadoContacto={this.configContactComponent}
                                                    // animalsControl={this.props.animalsControl}
                                                    // animalsControlDetail={this.props.animalsControlDetail}
                                                    changeModeEmail={this.changeModeEmail}
                                                    showModalContactByEmail={this.state.showModalContactByEmail}
                                                    onCloseModal={this.onCloseModalContact}
                                                    onClickSendEmail={this.onClickSendEmail}
                                                />
                                            </div>
                                        </div>
                                        {teaming &&
                                            <div>
                                                <h5>Donaciones</h5>
                                                <TeamingButton
                                                    id={this.props.infoProtectoraDetail._id}
                                                    nombre={this.props.infoProtectoraDetail.nombre}
                                                    teaming={teaming}
                                                    onShowButton={this.onShowButtonTeaming}
                                                    onClick={this.onClickButtonTeaming}
                                                />
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                            <Descripcion
                                title={"Información de " + this.props.infoProtectoraDetail.nombre}
                                nombre={this.props.infoProtectoraDetail.nombre}
                                descripcion={this.props.infoProtectoraDetail.descripcion}
                                onClickLink={this.clickLinkDescripcion}
                                onClickLinkTeaming={this.clickLinkTeamingDescripcion}
                                onClickEmail={this.clickEmailDescripcion}
                                adsConfig={{
                                    adsTypes: [ADS_TYPES.SPLITSCREEN, ADS_TYPES.ROBAPAGINAS],
                                    insertAtEnd: true
                                }}
                            />
                        </div>
                    }
                    
                    <div className="infoContactProtectora text-left">
                        <div className="moreProtectoraInfo">
                            <h4>Compartir</h4>
                            <ShareButtonsBox
                                shareURL={process.env.HOST_ADOPTA + PATH_PROTECTORA_ID + this.props.infoProtectoraDetail._id}
                                permalink={PATH_PROTECTORA_ID + this.props.infoProtectoraDetail._id}
                                text={""}
                                hashtags={["AdoptaNoCompres"]}
                                // onClickShareButton={this.onClickShareButton}
                                stickyMode
                                normalMode
                            />
                        </div>
                    </div>
                    {/*<AdsManagerContainer type={ADS_TYPES.MEGABANNER}/>*/}

                    <div className="imagenesProtectora borde-superior">
                        <h5 className="card-title">Fotos de {this.props.infoProtectoraDetail.nombre}</h5>
                        <CardCarrousellImages
                            // nombre={this.props.infoProtectoraDetail.nombre}
                            galeria_imagenes={this.props.infoProtectoraDetail.galeria_imagenes}
                        
                        />
                        {/*<div className="infoDetailProOneColumn">*/}
                        {/*    <a onClick={this.showImagenVideo} href="#" id="showImagesVideoProtectora" className="btn btn-outdivne-primary listing-houses__item-view-link">Ver fotos</a>*/}
                        {/*</div>*/}
                        {/*{this.props.showProtectora &&*/}
                        {/*    <ProtectoraImagesVideosDetail*/}
                        {/*        idProtectora={this.props.idProtectora}*/}
                        {/*    />*/}
                        {/*}*/}
                    </div>
                    <div className="borde-superior botonera-protectora-detail">
                        <a onClick={eventBack} href="#" id="btn_back_search"
                           className="btn btn-outline-primary listing-houses__item-view-link">{textBack}</a>
                        {this.props.access.isLogin && this.props.access.id === this.props.infoProtectoraDetail._id && this.props.isAdminAnimals &&
                            <a onClick={this.insertAnimal} href="#" id="btn_back_search"
                               className="btn btn-outline-primary listing-houses__item-view-link">Añadir animal</a>
                        }
                    
                    </div>
                </div>
            </div>
        );
    }
    
}

export default NewProtectoraDetail
